import { CheckboxGroupButtons } from '@/components/_common';
import ReportSelectMonthFields from '@/components/_common/ReportSelectMonthFields';
import {
  ReportVehicleWithoutMovementFormValues,
  VehiclesWithoutMovementOrderByColumn,
  VehiclesWithoutMovementWorkOrderSituationsFilter,
  VehiclesWithoutMovementWorkOrderTypeFilter,
} from '@/core/domain/reports/movements/vehicleWithoutMovements/vehicleWithoutMovements.types';
import { isAppPortocar } from '@/index';
import { Checkbox, Form, Radio, Typography } from 'antd';
import { FormInstance } from 'antd/es/form/Form';

interface Props {
  form: FormInstance<ReportVehicleWithoutMovementFormValues>;
}

export default function VehicleWithoutMovementForm({ form }: Props) {
  const osSituationOptions = [
    {
      value: VehiclesWithoutMovementWorkOrderSituationsFilter.open,
      label: 'Abertos',
    },
    {
      value: VehiclesWithoutMovementWorkOrderSituationsFilter.authorized,
      label: 'Autorizados',
    },
    {
      value: VehiclesWithoutMovementWorkOrderSituationsFilter.closed,
      label: 'Fechados',
    },
  ];

  const orderByColumnOptions = [
    {
      value: VehiclesWithoutMovementOrderByColumn.customer,
      label: 'Cliente',
    },
    {
      value: VehiclesWithoutMovementOrderByColumn.brand,
      label: 'Marca',
    },
    {
      value: VehiclesWithoutMovementOrderByColumn.model,
      label: 'Modelo',
    },
    {
      value: VehiclesWithoutMovementOrderByColumn.lastEntryDate,
      label: 'Última data de entrada',
    },
    {
      value: VehiclesWithoutMovementOrderByColumn.licensePlate,
      label: 'Placa',
    },
  ];

  const typeOptions = [
    {
      value: VehiclesWithoutMovementWorkOrderTypeFilter.workOrder,
      label: 'Orçamento',
    },
    {
      value: VehiclesWithoutMovementWorkOrderTypeFilter.warranty,
      label: 'Garantia',
    },
    {
      value: VehiclesWithoutMovementWorkOrderTypeFilter.return,
      label: 'Retorno',
    },
    {
      value: VehiclesWithoutMovementWorkOrderTypeFilter.courtesy,
      label: isAppPortocar ? 'Interna (Cortesia)' : 'Cortesia',
    },
    {
      value: VehiclesWithoutMovementWorkOrderTypeFilter.revision,
      label: 'Revisão',
    },
    {
      value: VehiclesWithoutMovementWorkOrderTypeFilter.totalLoss,
      label: 'Perda Total',
    },
  ];

  return (
    <Form form={form} layout="vertical">
      <ReportSelectMonthFields form={form} />

      <Form.Item
        name="workOrderSituationsFilter"
        label={
          <Typography.Title level={5} style={{ margin: '0' }}>
            Situação da O.S.
          </Typography.Title>
        }
        initialValue={[VehiclesWithoutMovementWorkOrderSituationsFilter.closed]}
      >
        <CheckboxGroupButtons options={osSituationOptions} />
      </Form.Item>

      <Form.Item
        name="workOrderTypeFilter"
        label={
          <Typography.Title level={5} style={{ margin: '0' }}>
            Tipo
          </Typography.Title>
        }
        initialValue={[VehiclesWithoutMovementWorkOrderTypeFilter.workOrder]}
      >
        <CheckboxGroupButtons options={typeOptions} />
      </Form.Item>

      <Form.Item
        name="orderByColumn"
        label={
          <Typography.Title level={5} style={{ margin: '0' }}>
            Ordenação de colunas
          </Typography.Title>
        }
        initialValue={VehiclesWithoutMovementOrderByColumn.customer}
      >
        <Radio.Group
          options={orderByColumnOptions}
          buttonStyle="solid"
          optionType="button"
          size="large"
        />
      </Form.Item>

      <Form.Item name="showInactiveCustomers" valuePropName="checked">
        <Checkbox>Mostrar clientes inativos?</Checkbox>
      </Form.Item>
    </Form>
  );
}
